<template>
  <div v-html="$t('end.text')"></div>
</template>

<script>
import ModConfig from "../modules/ModConfig";
import ModParticipant from "../modules/ModParticipant";

export default {
  mounted() {
    const redirectUrl = ModConfig.getRedirectUrl();
    const data = ModParticipant.data;
    const id = data.tan ? data.tan : data.id;
    const queries = this.$specs.queries || {};

    if (redirectUrl && id) {
      try {
        const url = new URL(redirectUrl, window.location.origin);
        url.searchParams.set("id", id);
        url.searchParams.set("aid", data.accountId);
        url.searchParams.set("pid", data.projectId);
        url.searchParams.set("e", data.e);
        url.searchParams.set("s", data.s);
        url.searchParams.set("n", data.n);
        url.searchParams.set("t", data.t);
        url.searchParams.set("f", data.f);
        url.searchParams.set("j", data.j);
        Object.entries(queries).forEach(([key, value]) => {
          if (!url.searchParams.has(key)) {
            url.searchParams.set(key, value);
          }
        });
        window.location.href = url.toString();
      } catch (e) {
        console.error("Redirect failed:", e);
      }
    } else {
      console.warn("No redirect performed. redirectUrl or id missing.");
    }
  },
};
</script>

<style>
.head {
  display: block !important;
}
</style>
